import axios from "axios";

// The ACCBF/Compass pilot's backend lives on the AmyloidConnect platform's
// API — same trusted infrastructure, same verified, tested endpoints. No
// auth needed here: these specific endpoints (/v1/accbf/*, /v1/copilot/ask
// with an accbf-* contextId) are intentionally public and rate-limit-exempt.
const api = axios.create({
  baseURL: "https://api.amyloidconnect.com",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
